import React from 'react';
import { Button, PrimaryButton } from 'glints-aries/lib/@next';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { openLoginSignUpModal } from 'src/actions/app';
import { ROUTES } from 'src/common/routes';
import { getRouterQueryProduct } from 'src/modules/SignUp/helper';

import * as S from './LoginNudgeView.sc';

export const LoginNudgeView = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  const handleSignUpClick = () => {
    const query = getRouterQueryProduct(router);
    router.push({
      pathname: '/signup',
      query,
    });
  };

  const handleLoginClick = () => {
    if (router.pathname !== `/${ROUTES.login}`) {
      dispatch(openLoginSignUpModal());
    }
  };

  return (
    <>
      <S.LoginNudgeViewContainer id="see-more-companies-login-nudge">
        <img
          alt="Magnifying glass icon"
          src="/images/icons/magnifying-glass.svg"
        />
        <S.Caption>
          <FormattedMessage
            id="text-log-in-to-see-more-companies"
            defaultMessage="Login to see more companies"
          />
        </S.Caption>
        <S.ButtonContainer>
          <Button
            onClick={handleSignUpClick}
            id="see-more-companies-signup-button"
          >
            <FormattedMessage id="signup" defaultMessage="Sign Up" />
          </Button>
          <PrimaryButton
            onClick={handleLoginClick}
            id="see-more-companies-login-button"
          >
            <FormattedMessage
              id="interactive-log-in-now"
              defaultMessage="Login Now"
            />
          </PrimaryButton>
        </S.ButtonContainer>
      </S.LoginNudgeViewContainer>
    </>
  );
};
